export const messages = {
  emptyEmail: 'Please enter email address.',
  invalidEmail: 'Please enter a valid email address.',
  emptyPassword: 'Please enter password.',
  passwordLength: 'Please enter atleast 6 digit password.',
  emptyName: 'Please enter first name.',
  emptyLastName: 'Please enter last name.',
  emptyconfirmPassword: 'Please confirm your password.',
  confirmPasswordError: 'Password does not match.',
  emptyTitle: 'Please enter title.',
  uploadFile: 'Please upload image.',
  notAllowedImg: 'Please select valid image.',
  imgLimit: 'Selected image is too large.',
  selectOnePermission: 'Please assign at least one permission.',
  season_title: 'Please enter season title.',
  emailBody: 'Please enter email body.',
  enterMessage: 'Please enter message.',
  selectRecipients: 'Please select recipients.',
  textMessage: 'Please enter SMS.',
  location_error: 'Please enter a location.',
  emptyTeamName:'Please enter team name.',
  duplicateTeamName:'Duplicate team name.',
  emptyTime: 'Please select preferred time.',
  selectLeague: 'Please select league.',
  addPlayer: 'Are you sure, you want to add this player to a team?',
  addPlayerTitle: 'Add Player.',
  deleteTeam: 'Are you sure, you want to delete the selected team?',
  status_select_error: 'Please select status.',
  sport_error: 'Please select a sport.',
  level_error: 'Please select level.',
  team_error: 'Please enter max teams.',
  gender_error: 'Please select gender.',
  elimination_error: 'Please select elimination type.',
  seeding_error: 'Please select seeding type.',
  hosted_error: 'Please select hosted by.',
  weeks_error: 'Please enter number of weeks.',
  games_error: 'Please enter number of games/team.',
  locationField_error: 'Please select locations and fields.',
  timeSlot_error: 'Please select time slot.',
  daysPlayed_error: 'Please select days played.',
  league_name_error: 'Please enter league name.',
  email_taken: 'Email already taken. Please try with a different email.',
  shirt_size_error: 'Please select a shirt size.',
  reg_deadline_error: 'Please select registration deadline.',
  start_date_error: 'Please select start date.',
  reg_fees_error: 'Please enter registration fee.',
  forfeit_fees_error: 'Please enter forfeit fee.',
  men_per_team_error: 'Please enter min number of men per team.',
  women_per_team_error: 'Please enter min number of women per team.',
  deleteCoupon: 'Are you sure, you want to delete the selected coupon?',
  contact_resolved_status: 'Are you sure, you want to change status to Resolved?',
  indv_reg_fees_error: 'Please enter individual registration fee.',
  menuItemName: 'Please enter menu item name.',
  menuItemDescription: 'Please enter menu item description.',
  menuItemPrice: 'Please enter menu item price.',
  optionName: 'Please enter option name.',
  optionDescription: 'Please enter option description.',
  optionPrice: 'Please enter option price.',
  couponName: 'Please enter coupon name.',
  field_error: 'Please select fields.',
  team1_error: 'Please select team 1.',
  team2_error: 'Please select team 2.',
  sectionName: 'Please enter section name.',
  priceOrQuantity: 'Please select minimum quantity or minimum price.',
  deliveryOrPickup: 'Please select requirement of delivery only or pickup only.',
  dollarOrPercentage: 'Please select savings value in dollar or percentage.',
  date: 'Please select start and end date of coupon.',
  bogoOrFreeDelivery: 'Please select discount on buy one get one or free delivery.',
  CouponCreatedSuccessfully: 'Coupon created successfully.',
  CouponUpdatedSuccessfully: 'Coupon Updated succcessfully.',
  empty_event_name: 'Please enter event name.',
  empty_event_description: 'Please enter event description.',
  empty_event_date: 'Please select a date.',
  empty_event_address: 'Please enter event address.',
  empty_event_start_time: 'Please enter start time.',
  empty_event_end_time: 'Please enter end time.',
  event_end_time_error: 'End time must be greater than start time.',
  event_group_size_error: 'Maximum group size must be equal or greater than minimum group size.',
  empty_driver_name: 'Please enter name.',
  empty_driver_email: 'Please enter email.',
  empty_driver_password: 'Please enter password.',
  empty_driver_confirm_password: 'Please enter confirm password.',
  empty_quote: 'Please enter quote.',
  empty_quote_person: 'Please enter name.',
  empty_announcement_title: 'Please enter title.',
  empty_announcement_message: 'Please enter message.',
  empty_announcement_image: 'Please enter an image.',
  empty_email_subject: 'Please enter email subject.',
  different_division_error: 'Drag and drop will work only for same division.',
  phoneLength: 'Please enter a valid phone number.',
  contact_un_resolved_status: 'Are you sure, you want to change status to Unresolved?',
  deleteTemplate: 'Are you sure, you want to delete the selected Template?',
  emptyTemplateName: 'Please enter template name.',
  emptyTemplateBody: 'Please enter template message.',
  emptyTemplateStatus: 'Please select a status.',
  noScheduling: 'Please create the schedule first to manipulate the schedule.',
  chargeTeam:'Would you like charge team with amount ${amount} ?',
  emptyField: 'Please fill this field.',
  validImage: 'Please select a valid image.',
  selectedFileSmall: 'Selected File too small.',
  selectTeam:'Please select team.',
  reschedulePlayoffHeader: 'Reschedule Playoff',
  reschedulePlayoffBody: 'Are you sure, you want to reschedule the playoff? All the playoff matches scored will be deleted.',
  fixedOldPlayoffHeader: 'Fixed Old Playoff',
  fixedOldPlayoffBody: 'Are you sure, you want to fixed the old playoff? None of the match score will be deleted.',
  emptyNoOfMatch: 'Please fill this field.',
  noOfMatchLessthanOne: 'Please enter a number greater than zero.',
  conflictedFields: 'Same Date Time and Fields are occupied in another leagues, Please goto the Weekly Matchups tab to fix those conflicts.',
  rescheduleMatchup: 'Are you sure, you want to reschedule the regular season?',
  emptyEventDetail: 'Please enter detail.',
  emptyEventType: 'Please select event type.',
  emptyEventvenue: 'Please select a venue.',
  emptyEventBudget: 'Please enter budget.',
  guestGreaterThanOne: 'No of guests should be greater than zero.',
  emptyOccasion: 'Please select an occasion.',
  title: 'Are you sure, you want to reschedule the regular season?',
  emptyDocType: 'Please select document type.',
  documentContent: 'Please add documet content',
  reasonRequired: 'Please enter rejection reason',
  event_end_time_same_greator: 'End date time should be greater than start date time',
  ticketGreaterThanZero: 'No of tickets should be greater than zero.',
  emptyUser: 'Please select a user.',
  priceGreaterThanZero: 'Price should be greater than zero.',
  bookingStartDateErr: 'Booking start date should be less than Event start date.',
  bookingDeadlineErr: 'Booking Deadline should be less than Event start date.',
  deleteTeamWithOrWithoutSchedule: 'Please select whether you want to delete this team with or without a schedule.',
  refundAmountLarge: 'Refund amount is greater than payment amount',
  invalidPhone: 'Please enter a valid phone number.',
  confirmCancelAll: 'Would like to cancel tickets?',
  confirmCancel: 'Would like to cancel this ticket?',
  invalidPhone: 'Please enter a valid phone number.',
  emptySelect: 'Please select this field.',
  bookingStartErr: 'Please enter booking start date.',
  bookingEndErr: 'Please enter booking end date.',
  bookingDateErr: 'Booking deadline should be greater than booking start date.',
  regularSeason: 'Regular season match are not completed',
  regularDivisionSeason: 'Regular season match for this division not completed',
  playoffStarted: 'Playoff matches already started',
  invlaidUrl: 'Invalid url.',
  division_error: 'Only four division are valid',
  per_division_error: 'Max 16 teams are allowed',
  selectSendTo: 'Please select send to.',
  dayIsRequired: 'Please select a day.',
  scheduleTypeIsRequired: 'Please select a schedule type.',
  timeIsRequired: 'Please select a time.',
  hoursBeforeIsRequired: 'Please select hours before.',
  messageTemplateIsRequired: 'Please enter message template.',
  rescheduleMessageTemplateIsRequired: 'Please enter reschedule message template.',
  cancelMessageTemplateIsRequired: 'Please enter cancel message template.',
  selectDateAndTime: 'Please select date and time.',
  advertisementForError: 'Please select an advertisement for.',
};
